<template>
  <vxe-modal
    ref="xModal"
    v-model="formVisible"
    :title="'权限' + modalType"
    width="80%"
    height="80%"
    show-zoom
    @zoom="zoomWindow"
    @show="showModal"
    :before-hide-method="beforeHideModal"
    @close="closeModal"
  >
    <el-form
      :model="form"
      ref="FormRef"
      :validate-on-rule-change="false"
      :rules="rules"
      size="small"
    >
      <!-- 第一行 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="角色名称" prop="name">
            <el-input
              v-model="form.name"
              autocomplete="off"
              :placeholder="placeholderConfig.input"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <YKDivider>菜单列表</YKDivider>
    <!-- <el-divider content-position="left">菜单列表</el-divider> -->
    <!-- 菜单权限明细table -->
    <vxe-grid
      ref="xTable1"
      size="mini"
      :column-config="{ minWidth: '80px' }"
      border
      keep-source
      :height="tableHeight1"
      :cell-class-name="cellClassName1"
      resizable
      :edit-rules="validRules1"
      show-overflow
      :data="form.detailListBRoleAuthority"
      highlight-hover-row
      highlight-current-row
      :mouse-config="{ area: true, extension: true }"
      :edit-config="{
        trigger: 'dblclick',
        mode: 'cell',
        activeMethod: activeMethod1
      }"
      :keyboard-config="{
        isArrow: true,
        isEnter: true,
        isTab: true,
        isClip: true,
        enterToTab: true,
        isEdit: true,
        editMethod: editMethod1
      }"
      @cell-click="cellClickEvent1"
      :menu-config="{
        body: { options: bodyMenus1 },
        visibleMethod: visibleMethod1
      }"
      :columns="gridColumns1"
      @menu-click="contextMenuClickEvent1"
      :toolbar="tableToolbar"
      @toolbar-button-click="toolbarButtonClickEvent"
    >
    </vxe-grid>
    <!-- <el-divider content-position="left">人员列表</el-divider> -->
    <YKDivider>人员列表</YKDivider>
    <vxe-grid
      ref="xTable2"
      size="mini"
      :column-config="{ minWidth: '80px' }"
      border
      keep-source
      :height="tableHeight2"
      :cell-class-name="cellClassName2"
      resizable
      :edit-rules="validRules2"
      show-overflow
      :data="form.detailListBRoleEmployee"
      highlight-hover-row
      highlight-current-row
      :mouse-config="{ area: true, extension: true }"
      :edit-config="{
        trigger: 'dblclick',
        mode: 'cell',
        activeMethod: activeMethod2
      }"
      :keyboard-config="{
        isArrow: true,
        isEnter: true,
        isTab: true,
        isClip: true,
        enterToTab: true,
        isEdit: true,
        editMethod: editMethod2
      }"
      :menu-config="{
        body: { options: bodyMenus2 },
        visibleMethod: visibleMethod2
      }"
      :columns="gridColumns2"
      @menu-click="contextMenuClickEvent2"
      :toolbar="tableToolbar2"
      @toolbar-button-click="toolbarButtonClickEvent"
    >
    </vxe-grid>
    <!-- 间隔槽（内含保存按钮） -->
    <div class="gap-dv">
      <button @click="save">保存</button>
    </div>
    <!-- 角色选择框 -->
    <EmployeeSelect ref="EmployeeSelect" @sureBackPerson="sureBackPerson" />
    <!-- 菜单选择框 -->
    <MenuSelect ref="MenuSelect" @sureSelectBack="sureSelectMenu"></MenuSelect>
    <!-- 菜单选择框 -->
    <MenuSpecial ref="MenuSpecial"></MenuSpecial>
  </vxe-modal>
</template>
<script>
import MenuSelect from './MenuSelect.vue'
import MenuSpecial from './MenuSpecial'
export default {
  components: {
    MenuSelect,
    MenuSpecial
  },
  props: {
    modalType: {
      type: String,
      default: '新增'
    },
    parentData: {
      type: Object,
      default: () => {
        return {
          Authority: {
            see: false,
            edit: false
          }
        }
      }
    },
    updateForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      id: 0,
      formVisible: false,
      form: {
        id: 0,
        name: '',
        detailListBRoleAuthority: [],
        detailListBRoleEmployee: [],
      },
      rules: {

      },
      // 数据列
      tableColumns1: [],
      tableColumns2: [],
      // 明细验证规则
      validRules1: {},
      // 明细验证规则
      validRules2: {},
      // 明细验证错误
      errIndex: [],
      bodyMenus1: [
        [
          {
            code: 'delete',
            comments: '删除',
            name: '删除',
            value: '删除'
          }
        ]
      ],
      bodyMenus2: [
        [
          {
            code: 'delete',
            comments: '删除',
            name: '删除',
            value: '删除'
          }
        ]
      ],
      // 列头1
      gridColumns1: [],
      // 列头2
      gridColumns2: [],
      // 高度百分百比
      zoomHeightRatio: 0.8,
      // tabel工具栏
      tableToolbar: {},
      tableToolbar2: {},
      // 是否修改过
      IfExistModify: false,
      IfDataBindComplete: false
    }
  },
  created () {
    this.InitColumn()
  },
  methods: {
    // 初始化列头
    InitColumn () {
      let that = this
      that.gridColumns1 = [
        { type: 'seq', width: '40', cellType: 'string' },
        { field: 'delete', title: '删除', width: '50', align: 'center', slots: { default: ({ row }) => { return [<i id="vxeDelete" class="el-icon-delete-solid" onClick={() => { this.handleCellDelete(row) }} ></i>] } } },
        {
          field: 'module',
          title: '模块',
          filters: [{ data: null }],
          filterRender: { name: 'FilterInput' }
        },
        {
          field: 'text',
          title: '菜单',
          filters: [{ data: null }],
          filterRender: { name: 'FilterInput' }
        },
        {
          field: 'iSee',
          title: '查看',
          align: 'center',
          slots: {
            header: () => {
              return [
                <vxe-checkbox v-model={this.iSeeAll} onChange={
                  () => {
                    this.checkboxiSee()
                  }
                }>查看</vxe-checkbox>
              ]
            },
            default: ({ row }) => {
              return [
                <vxe-checkbox v-model={row.iSee}></vxe-checkbox>
              ]
            }
          }
        },
        {
          field: 'iEdit',
          title: '编辑',
          align: 'center',
          slots: {
            header: () => {
              return [
                <vxe-checkbox v-model={this.iEditAll} onChange={
                  () => {
                    this.checkboxiEdit()
                  }
                }>编辑</vxe-checkbox>
              ]
            },
            default: ({ row }) => {
              return [
                <vxe-checkbox v-model={row.iEdit}
                  disabled={row.alifRead === '是'}></vxe-checkbox>
              ]
            }
          }
        },
        { field: 'type', title: '菜单类型', cellType: 'string' },
        {
          field: 'more',
          title: '更多',
          align: 'center',
          slots: {
            default: ({ row }) => {
              return [
                <el-button type="text" size="small" disabled={!row.hasSpecial}>更多</el-button>
              ]
            }
          }
        }
      ]
      that.gridColumns2 = [
        { type: 'seq', width: '40', cellType: 'string' },
        { field: 'delete', title: '删除', width: '50', align: 'center', slots: { default: ({ row }) => { return [<i id="vxeDelete" class="el-icon-delete-solid" onClick={() => { this.handleCellDeleteOA(row) }} ></i>] } } },
        { field: 'name', title: '姓名', cellType: 'string' },
        { field: 'num', title: '用户名', cellType: 'string' },
        { field: 'post', title: '职位', cellType: 'string' }
      ]
    },
    // 获取权限
    InitRight () {
      // tabel工具栏
      this.tableToolbar = {
        buttons: [
          {
            code: 'pickMenu',
            disabled: !this.parentData.Authority.edit,
            name: '选择菜单'
          }
        ]
      }
      this.tableToolbar2 = {
        buttons: [
          {
            code: 'pickMan',
            disabled: !this.parentData.Authority.edit,
            name: '选择人员'
          }
        ]
      }
    },
    async showModal () {
      this.setFormVaild()
      this.InitRight()
      this.IfDataBindComplete = false
      switch (this.modalType) {
        case '新增':
          this.id = 0
          this.form = {
            id: 0,
            name: '',
            detailListBRoleAuthority: [],
            detailListBRoleEmployee: []
          }
          break
        case '修改':
          this.id = this.updateForm.id
          await this.getBoth(this.id)
          break
      }
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
        this.IfDataBindComplete = true
        this.IfExistModify = false
      })
    },
    // 获取明细数据
    async getBoth (id) {
      this.id = id
      const { data: res } = await this.$http.get('/Base/BRole/both',
        {
          params: {
            id: id
          }
        }
      )
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.form = res.data
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
        this.IfExistModify = false
      })
    },
    async beforeHideModal () {
      if (!(await this.closeModal())) {
        return new Error()
      }
    },
    async closeModal () {
      let ifClose = false
      if (this.IfExistModify) {
        await this.$confirm('您已做出修改，是否关闭窗口？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            ifClose = true
          })
          .catch(() => {
          })
      } else {
        ifClose = true
      }
      return ifClose
    },
    // 最大化事件
    zoomWindow (e) {
      if (e.type === 'max') {
        this.zoomHeightRatio = 1
      } else {
        this.zoomHeightRatio = 0.8
      }
    },
    toolbarButtonClickEvent ({ code }) {
      switch (code) {
        case 'pickMenu':
          this.handlePickMenu()
          break
        case 'pickMan':
          this.handlePickMan()
          break
      }
    },
    // 选择菜单
    handlePickMenu () {
      if (this.parentData.Authority.edit) {
        this.$refs.MenuSelect.formVisible = true
      }
    },
    sureSelectMenu (selectRecords) {
      if (selectRecords.length > 0) {
        for (let item of selectRecords) {
          let isNotHave = true
          let detailList = this.$refs.xTable1.getTableData()
          for (let detail of detailList.fullData) {
            if (detail.bAuthorityListID === item.id) {
              isNotHave = false
              break
            }
          }
          if (isNotHave) {
            let record = {
              id: 0,
              module: item.module,
              text: item.text,
              broleID: this.id,
              bAuthorityListID: item.id,
              iSee: false,
              iEdit: false,
              type: item.type,
              ifRead: item.ifRead,
              effectCondition: item.effectCondition
            }
            this.$refs.xTable1.insertAt(record, -1)
          }
        }
        this.IfExistModify = true
      }
    },
    // 选择人员
    handlePickMan () {
      if (this.parentData.Authority.edit) {
        this.$refs.EmployeeSelect.formVisible = true
      }
    },
    // 返回人员
    sureBackPerson (list) {
      if (list.length > 0) {
        for (let item of list) {
          let isNotHave = true
          let detailList = this.$refs.xTable2.getTableData()
          // let id = String(item).split('@')[0]
          // let num = String(item).split('@')[1]
          // let name = String(item).split('@')[2]
          // let post = String(item).split('@')[3]
          for (let detail of detailList.fullData) {
            if (Number(detail.ykUserID) === Number(item.id)) {
              isNotHave = false
              break
            }
          }
          if (isNotHave) {
            let record = {
              ykUserID: item.id,
              num: item.num,
              name: item.name,
              post: item.post
            }
            this.$refs.xTable2.insertAt(record, -1)
          }
        }
        this.IfExistModify = true
      }
    },
    // 初始化校验规则
    setFormVaild () {
      this.rules = {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'change' },
          {
            min: 0,
            max: 32,
            message: '角色名称长度应在 0 到 32 个字符',
            trigger: 'change'
          }
        ]
      }
    },
    // 保存
    save () {
      this.validEnter().then(async result => {
        if (result) {
          if (this.id && this.id > 0) {
            this.update()
          } else {
            this.add()
          }
        }
      })
    },
    // 新增
    async add () {
      let form = { ...this.form }
      let insertRecords1 = this.$refs.xTable1.getInsertRecords()
      form.detailListBRoleAuthority = insertRecords1
      let insertRecords2 = this.$refs.xTable2.getInsertRecords()
      form.detailListBRoleEmployee = insertRecords2
      form = this.removeObjectNull(form)
      form.detailListBRoleAuthority = this.removeArrayNull(form.detailListBRoleAuthority)
      form.detailListBRoleEmployee = this.removeArrayNull(form.detailListBRoleEmployee)
      const { data: res } = await this.$http.post('/Base/BRole/both', form)
      if (res.isSuccess) {
        this.id = res.data
        // this.BindText()
        this.$message.success(this.messageConfig.save.success)
        this.parentData['list']('add', res.data)
        // this.formVisible = false
        // this.modalType = '修改'
        this.$emit('updateModalType', '修改')
        this.id = res.data
        this.getBoth(res.data)
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 修改
    async update () {
      let form = { ...this.form }
      let insertRecords1 = this.$refs.xTable1.getInsertRecords()
      let removeRecords1 = this.$refs.xTable1.getRemoveRecords()
      let updateRecords1 = this.$refs.xTable1.getUpdateRecords()
      form.detailListBRoleAuthority = []
      for (let item of insertRecords1) {
        form.detailListBRoleAuthority.push(item)
      }
      for (let item of removeRecords1) {
        item.id = item.id > 0 ? 0 - item.id : item.id
        form.detailListBRoleAuthority.push(item)
      }
      for (let item of updateRecords1) {
        form.detailListBRoleAuthority.push(item)
      }
      let insertRecords2 = this.$refs.xTable2.getInsertRecords()
      let removeRecords2 = this.$refs.xTable2.getRemoveRecords()
      let updateRecords2 = this.$refs.xTable2.getUpdateRecords()
      form.detailListBRoleEmployee = []
      for (let item of insertRecords2) {
        form.detailListBRoleEmployee.push(item)
      }
      for (let item of removeRecords2) {
        item.id = item.id > 0 ? 0 - item.id : item.id
        form.detailListBRoleEmployee.push(item)
      }
      for (let item of updateRecords2) {
        form.detailListBRoleEmployee.push(item)
      }

      form = this.removeObjectNull(form)
      form.detailListBRoleAuthority = this.removeArrayNull(form.detailListBRoleAuthority)
      form.detailListBRoleEmployee = this.removeArrayNull(form.detailListBRoleEmployee)
      const { data: res } = await this.$http.put('/Base/BRole/both', form)
      if (res.isSuccess) {
        this.$message.success(this.messageConfig.save.success)
        this.parentData['list']('update', this.form.id)
        this.getBoth(this.id)
        // this.formVisible = false
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 验证
    async validEnter () {
      let flag = true
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      this.errIndex = []
      const errMap = await this.$refs.xTable1.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              this.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex
              })
            })
          })
        })
        if (this.errIndex.length > 0) {
          flag = false
        }
      }
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 单元格设置样式,错误提示
    cellClassName1 ({ row, columnIndex }) {
      var a = this.errIndex.find(item => {
        return item._XID === row._XID && item.columnIndex === columnIndex
      })
      if (a) {
        return 'cell-valid'
      }
    },
    // 单元格设置样式,错误提示
    cellClassName2 ({ row, columnIndex }) {
      var a = this.errIndex.find(item => {
        return item._XID === row._XID && item.columnIndex === columnIndex
      })
      if (a) {
        return 'cell-valid'
      }
    },
    // cell激活控制
    activeMethod1 ({ column }) {
      if (!this.parentData.Authority.edit) {
        return false
      }
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      return true
    },
    // cell激活控制
    activeMethod2 ({ column }) {
      if (!this.parentData.Authority.edit) {
        return false
      }
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      return true
    },
    // cell编辑控制
    editMethod1 ({ row, column, $table }) {
      if (!this.parentData.Authority.edit) {
        return false
      }
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },
    // cell编辑控制
    editMethod2 ({ row, column, $table }) {
      if (!this.parentData.Authority.edit) {
        return false
      }
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },
    // 点击单元格
    cellClickEvent1 ({ row, column }) {
      if (column.title === '更多' && row.hasSpecial) {
        if (row.id > 0) {
          this.$refs.MenuSpecial.roleID = this.id
          this.$refs.MenuSpecial.bAuthorityListID = row.bAuthorityListID
          this.$refs.MenuSpecial.ifCanSave = this.parentData.Authority.edit
          this.$refs.MenuSpecial.formVisible = true
        } else {
          this.$message.warning('行明细未保存，请先保存')
        }
      }
    },
    // 快捷键
    visibleMethod1 ({ options, column }) {
      options.forEach(list => {
        list.forEach(item => {
          item.disabled = !this.parentData.Authority.edit
          if (!column) {
            item.visible = false
          } else if (['delete'].includes(item.code)) {
            item.visible = true
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    async contextMenuClickEvent1 ({ menu }) {
      if (menu.code === 'delete') {
        const areas = this.$refs.xTable1.getCellAreas()
        const a = this.megerArea(areas)
        this.$messagebox
          .confirm(this.messageConfig.del.confirmTableRow, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            this.$refs.xTable1.remove(a.rows)
            this.IfExistModify = true
          })
          .catch(() => { })
      }
    },
    // 快捷键
    visibleMethod2 ({ options, column }) {
      options.forEach(list => {
        list.forEach(item => {
          item.disabled = !this.parentData.Authority.edit
          if (!column) {
            item.visible = false
          } else if (['delete'].includes(item.code)) {
            item.visible = true
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    async contextMenuClickEvent2 ({ menu }) {
      if (menu.code === 'delete') {
        const areas = this.$refs.xTable2.getCellAreas()
        const a = this.megerArea(areas)
        this.$messagebox
          .confirm(this.messageConfig.del.confirmTableRow, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            this.$refs.xTable2.remove(a.rows)
            this.IfExistModify = true
          })
          .catch(() => { })
      }
    },
    filteralText ({ option, row }) {
      return row.alText.indexOf(option.data) !== -1
    },
    // 模块筛选
    filteralModule ({ option, row }) {
      return row.alModule.indexOf(option.data) !== -1
    },

    checkboxiSeeZiJi () {
      let records = this.$refs.xTable1.getTableData().visibleData
      for (let i = 0; i < records.length; i++) {
        records[i].iSeeZiJi = this.iSeeZiJiAll
      }
    },
    checkboxiSeeDept () {
      let records = this.$refs.xTable1.getTableData().visibleData
      for (let i = 0; i < records.length; i++) {
        records[i].iSeeDept = this.iSeeDeptAll
      }
    },
    checkboxiSeeCompany () {
      let records = this.$refs.xTable1.getTableData().visibleData
      for (let i = 0; i < records.length; i++) {
        records[i].iSeeCompany = this.iSeeCompanyAll
      }
    },
    checkboxiSee () {
      let records = this.$refs.xTable1.getTableData().visibleData
      for (let i = 0; i < records.length; i++) {
        records[i].iSee = this.iSeeAll
      }
    },
    checkboxiEdit () {
      let records = this.$refs.xTable1.getTableData().visibleData
      for (let i = 0; i < records.length; i++) {
        if (records[i].alifRead !== '是') {
          records[i].iEdit = this.iEditAll
        }
      }
    },
    // 删除行
    handleCellDelete (row) {
      this.$confirm('确定要删除本行吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$refs.xTable1.remove(row)
          this.IfExistModify = true
        })
        .catch(() => { })
    },
    handleCellDeleteOA (row) {
      this.$confirm('确定要删除本行吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$refs.xTable2.remove(row)
          this.IfExistModify = true
        })
        .catch(() => { })
    }
  },
  computed: {
    tableHeight1 () {
      const titleHeight = 42.5
      const formHeight = 66
      const divider = this.$store.state.ykDivider
      const buttonHeight = 40
      let height = (Number(this.$store.state.clientHeight) * this.zoomHeightRatio - 25 -
        titleHeight - formHeight - (divider * 2) - buttonHeight) * 0.6
      return height + 'px'
    },
    tableHeight2 () {
      const titleHeight = 42.5
      const formHeight = 66
      const divider = this.$store.state.ykDivider
      const buttonHeight = 40
      let height = (Number(this.$store.state.clientHeight) * this.zoomHeightRatio - 25 -
        titleHeight - formHeight - (divider * 2) - buttonHeight) * 0.4
      return height
    }
  },
  watch: {
    form: {
      handler () {
        if (this.IfDataBindComplete) {
          this.IfExistModify = true
        }
      },
      deep: true
    }
  }
}
</script>
<style lang='less' scoped>
// 间隔槽总高度 = 高度 + margin
@gap-margin: 10px;
@gap-height: 30px;
@gap-padding-bottom: 10px;
.gap-dv {
  width: 100%;
  height: @gap-height;
  margin: @gap-margin 0 0 0;
  // padding-bottom: @gap-padding-bottom;
  // border-bottom: 1px solid #f2f3f5;
  .fl;

  > button {
    width: 180px;
    height: 30px;
    font-size: 14px;
    border-radius: 5px;
    background-color: @primary-color;
    color: @text-color;
    outline: none;
    border: none;
    transition: @normal-transition;
  }

  > button:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  > button:active {
    opacity: 0.9;
  }
}
#vxeDelete {
  color: red;
}
</style>